import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import moment from 'moment';

import { fade } from '@material-ui/core/styles/colorManipulator';

import api from "../../../api/backend"

import Editor from './Editor'
import New from './New'

const styles = theme => ({
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class Register extends React.Component {
    state = {
        open: false, list: [], tmpList: [], courses: [], tmpCourses: [], level: '', course: '', term: ''
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    getAllRegisterCourse = () => {
        api.getAllRegisterCourse().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ list: json, tmpList: json })
            }
        }).catch(() => { })
    }

    getCourses = () => {
        api.getAllCourses().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ courses: json, tmpCourses: json })
            }
        }).catch(() => { })
    }

    find = () => {
        const { tmpList, term, level, course } = this.state
        console.log(term, level, course)
        let ls = tmpList
        // if (term.length > 0) {
        //     this.setState({
        //         list: tmpList.filter((e) => {
        //             return (e.user ? e.user.firstName.includes(term) : null || e.user ? e.user.lastName.includes(term) : null
        //                 || e.subject.title.includes(term) || e.myCourse.course.title.includes(term))
        //         })
        //     })
        // } else {
        //     this.setState({ list: tmpList })
        // }

        if (term.length > 0) {
            ls = ls.filter((e) => {
                return (e.user ? e.user.firstName.includes(term) : null || e.user ? e.user.lastName.includes(term) : null
                    || e.subject.title.includes(term) || e.myCourse.course.title.includes(term))
            })
        }
        if (level.length > 0) {
            ls = ls.filter((e) => {
                return e.subject.level.includes(level)
            })
        }
        if (course.length > 0) {
            console.log('course', course)
            ls = ls.filter((e) => {
                return e.myCourse.course.title.includes(course)
            })
        }

        this.setState({ list: ls })
    }

    componentDidMount() {
        this.getAllRegisterCourse();
        this.getCourses();
    }

    render() {
        const { classes } = this.props;
        const { list } = this.state;
        return (
            <div>
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            รายการลงทะเบียนเรียน
            </Typography>
                        {/* <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.find()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div> */}
                        <div className={classes.search}>
                            <Button fullWidth style={{ color: 'white' }} onClick={() => { this.setState({ term: '', level: '', course: '', openSearch: true }) }}>ค้นหา</Button>
                            <Dialog fullWidth maxWidth="sm" disableBackdropClick disableEscapeKeyDown open={this.state.openSearch} onClose={() => { this.setState({ openSearch: false }) }}>
                                <DialogTitle>ค้นหารายการลงทะเบียน</DialogTitle>
                                <DialogContent>
                                    <form className={classes.container}>
                                        <FormControl className={classes.formControl} fullWidth>
                                            <InputLabel shrink htmlFor="level-native-simple">ค้นหา</InputLabel>
                                            <TextField
                                                id="standard-term"
                                                className={classes.textField}
                                                value={this.state.term}
                                                onChange={this.handleChange('term')}
                                                margin="normal"
                                            />
                                        </FormControl>
                                        <FormControl className={classes.formControl} fullWidth>
                                            <InputLabel shrink htmlFor="level-native-simple">ระดับชั้น</InputLabel>
                                            <Select
                                                value={this.state.level}
                                                input={<Input id="level-simple" />}
                                                onChange={(event) => {
                                                    let c = this.state.tmpCourses.filter((e) => {
                                                        return e.subject.level.includes(event.target.value)
                                                    })
                                                    this.setState({ level: event.target.value, courses: c })

                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 1">ประถมศึกษา ปีที่ 1</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 2">ประถมศึกษา ปีที่ 2</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 3">ประถมศึกษา ปีที่ 3</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 4">ประถมศึกษา ปีที่ 4</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 5">ประถมศึกษา ปีที่ 5</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 6">ประถมศึกษา ปีที่ 6</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 1">มัธยมศึกษา ปีที่ 1</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 2">มัธยมศึกษา ปีที่ 2</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 3">มัธยมศึกษา ปีที่ 3</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 4">มัธยมศึกษา ปีที่ 4</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 5">มัธยมศึกษา ปีที่ 5</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 6">มัธยมศึกษา ปีที่ 6</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormControl className={classes.formControl} fullWidth>
                                            <InputLabel shrink htmlFor="course-simple">คอร์ส</InputLabel>
                                            <Select
                                                value={this.state.course}
                                                input={<Input id="course-simple" />}
                                                onChange={this.handleChange('course')}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {this.state.courses.map(course => (
                                                    <MenuItem value={course.course.title}>{course.course.title}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => { this.setState({ openSearch: false }) }} color="primary">
                                        Cancel
                                </Button>
                                    <Button onClick={() => {
                                        this.find();
                                        this.setState({ openSearch: false });
                                    }} color="primary">
                                        Ok
                                </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>

                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <New onCreated={this.getAllRegisterCourse} />
                        </Grid>
                    </Grid>
                    <br /> <br />
                    <Paper>
                        <Table padding='dense'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ชื่อนักเรียน</TableCell>
                                    {/* <TableCell>วิชา</TableCell> */}
                                    <TableCell>คอร์ส</TableCell>
                                    <TableCell>วันที่เริ่ม</TableCell>
                                    <TableCell align="right">ประเภท</TableCell>
                                    <TableCell align="right">สถานะชำระเงิน</TableCell>
                                    <TableCell align="right">ชื่อเล่น</TableCell>
                                    {/* <TableCell align="right">สถานะ</TableCell> */}
                                    <TableCell style={{ width: 200 }}>สถานะ</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.sort((a, b) => { return b.myCourse.id - a.myCourse.id }).map(l => (
                                    <TableRow key={l.myCourse.id}>
                                        <TableCell component="th" scope="row">
                                            {l.user ? `${l.user.firstName} ${l.user.lastName}` : l.myCourse.user}
                                        </TableCell>
                                        {/* <TableCell>{l.subject.title}</TableCell> */}
                                        <TableCell>{l.myCourse.course.title}</TableCell>
                                        <TableCell>{moment(l.myCourse.course.startDate).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="right">{l.myCourse.type}</TableCell>
                                        <TableCell align="right">{l.myCourse.paymentStatus === 'Inprogress' ? <p style={{ color: 'red' }}>รอชำระ</p> : 'ชำระแล้ว'}</TableCell>
                                        <TableCell align="right">{l.user ? `${l.user.nickName}` : ''}</TableCell>
                                        {/* <TableCell align="right">{l.myCourse.deactivated ? <p style={{ color: 'red' }}>ไม่ใช้งาน</p> : 'ใช้งาน'}</TableCell> */}
                                        <TableCell><Editor course={l.myCourse} onUpdateCompleted={this.getAllRegisterCourse} /></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </div>
        );
    }
}

Register.propTypes = {
};

export default withStyles(styles)(Register);